import React from 'react';
import Hero from '../components/Hero';
import QuickNav from '../components/QuickNav';

const HomePage = () => {
  return (
    <>
      <Hero />
      <QuickNav />
    </>
  );
};

export default HomePage;
